<script>
import { chartHelpers } from "./Charts";
import { Line, mixins } from 'vue-chartjs';

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default(){
        return {
          labels: [],
          datasets: []
        };
      },
    },
    options: {
      type: Object,
      default(){
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: {display:false, position:'bottom', labels:{pointStyle:'circle', usePointStyle: true}},
          events: [], 
          animation: false, 
          elements: {
            line: {
              borderColor: 'transparent',
              fill: true
            },
            point: {
              radius: 0,
            }
          },
          scales:{
              yAxes:[{gridLines: {display: true}}]
          }
        };
      }
    },
    init: Object,
    loadMore: Object,
    counter: Object,
    live: {
      type: Boolean,
      default: true
    },
    speed: {
      type: Number,
      default: 700
    },
    maxIntervals: {
      type: Number,
      default: 40
    }
  },
  data() {
    return {
      cData: this.chartData,
      ctr: 0,
      interval: {}
    }  
  },
  computed: {
    mergedData: function () {
      return chartHelpers.mergeColorsIntoData(this.cData);
    }
  },
  mounted() {
    // request initial data
    this.$emit('init', this.cData);
    this.renderChart(this.cData, this.options);
    if (this.live===true) {
      this.startInterval();
    }
  },
  methods: {
      startInterval () {
        var _self = this;
        this.interval = setInterval(function(){
          if (_self.ctr === _self.maxIntervals || _self.chartData === "undefined") {
            clearInterval(_self.interval);
          }
          else {
            _self.ctr++;
            _self.$emit('load-more');
          }
        },this.speed);
      },
  },
  watch: {
    live: {
      handler: function (val) {
        if (!this.live) {
          //stop
          clearInterval(this.interval);
          this._chart.options.events = ['click'];
          this._chart.update();
        }
        else {
          //start
          this.startInterval();
          this._chart.options.events = [];
          this._chart.update();
        }
      }
    },
    'chartData.datasets': {
      handler() {
        this.renderChart(this.mergedData, this.options);
      }
    },
    ctr: {
      handler(val) {
        this.$emit('counter',val);
      }
    },
    deep: true
  }
};
</script>
